import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import {IamService} from '../../services/iam.service';
import { MeService } from 'src/app/services/me.service';

@Injectable()
export class AuthGuardService  {

  failedUrl?: string = null;
  route_name: string;
  constructor(private auth: AuthService, private router: Router,
              private iam: IamService, public route: ActivatedRoute, private me: MeService) {
  }

  consumeFailedUrl(): string {
    let url = this.failedUrl;
    this.failedUrl = null;
    return url;
  }

  applies2fa(routeSnapshot: ActivatedRouteSnapshot) {
    // 
    // 
    // 

    // Verifica que aplique doble factor de autenticación
    // Y que tenga seteado el user la variable secret
    if (this.me.user.applies_double_authentication_factor && !this.me.user.secret) {

      // Verify is active route has a valid url
      // and validate if active route is authenticator config
      if (routeSnapshot.routeConfig.path.length && routeSnapshot.routeConfig.path.indexOf("verification/activate") == -1) {
        this.router.navigate(['/admin/verification/activate']);
      }

    } else {
      // Redireccionar al management si se intenta entrar
      // a la configuración del autenticador y no se tiene
      // seteada la bandera de habilitar 2FA en el user loggeado
      if (routeSnapshot.routeConfig.path.indexOf("verification/activate") >= 0) {
        this.router.navigate(['admin/management'],{queryParams:{welcome: true}});
      }

    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (this.auth.isAuthenticated()) {

      // Verify if applies 2fa
      this.applies2fa(route)

      return Promise.resolve(true);
    }
    if (this.auth.canAutoLogin()) {
      return this.auth.autoLogin()
        .then(() => {

          // Verify if applies 2fa
          this.applies2fa(route)

          return true
        })
        .catch(() => {
          this.auth.logout();
          this.failedUrl = state.url;
          this.router.navigate(['/admin/login']);
          return false;
        })
    }
    this.failedUrl = state.url;
    this.router.navigate(['/admin/login']);
    return Promise.resolve(false);
  }

}
